import Body from '@ausbom/body/lib/Body';
import Typography from '@ausbom/typography/lib/Typography';
import { Link } from '@core-systems/frontend-shared';
import { getEnvironment } from '@env';
import AppHero from '../../components/AppHero/AppHero';
import Page from '../../components/Page/Page';

export default function PageError() {
  const bomUrl = getEnvironment().siteUrls.bom;
  return (
    <>
      <AppHero title="Page not available" isoBars={1} />
      <Page>
        <Body>
          <Typography as="h4" styleName="heading-m" isResponsive>
            Sorry, we can't access that page right now.
          </Typography>
          <Typography as="p" styleName="body" isResponsive>
            Check the address and try again, or visit our homepage:{' '}
            <Link href={bomUrl} external={true} title="Bureau of Meteorology homepage" />
          </Typography>
        </Body>
      </Page>
    </>
  );
}
